// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-select.select {
  margin: 0px;
}

.row {
  align-items: center;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

.red {
  color: #d3001d;
}

.globalLimit {
  padding-bottom: 10px;
}

.timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective, .timePendingLimitEffective {
  display: none;
  width: 100%;
}

.button-row {
  justify-content: center;
  display: grid;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.label-colum {
  display: flex;
  align-items: center;
}

.label-text {
  text-overflow: "-";
  white-space: nowrap;
}

.deposit-column {
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

hr {
  border: 0;
  height: 1px;
  background: #C2C2C2;
}

.error-message {
  color: var(--ion-color-danger);
  font-size: 12px;
  margin-top: 4px;
}

.limit-section {
  display: flex;
  flex-direction: column;
}
.limit-section .limit-info {
  align-items: center;
  justify-content: space-between;
}
.limit-section .limit-info .label-text {
  font-size: 16px;
  font-weight: 500;
}
.limit-section .limit-info .timeDelete {
  display: flex;
  justify-content: flex-end;
}
.limit-section .new-limit-row {
  align-items: center;
}
.limit-section .new-limit-row h5 {
  margin: 0;
}
.limit-section .new-limit-row ion-input {
  --padding-start: 10px;
}

.section-divider {
  margin: 20px 0;
  border: none;
  height: 1px;
  background-color: var(--ion-color-light-shade);
}

.rollover-period {
  display: none;
  width: 100%;
}

.new-limit-effective {
  display: none;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/limits/set-time-limits/set-time-limits.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;;AAGI;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AAAR;;AAGI;EACI,cAAA;AAAR;;AAGI;EACI,oBAAA;AAAR;;AAGI;EACI,aAAA;EACA,WAAA;AAAR;;AAGI;EACI,uBAAA;EACA,aAAA;AAAR;;AAII;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;;AAII;EACI,aAAA;EACA,mBAAA;AADR;;AAII;EACI,kBAAA;EACA,mBAAA;AADR;;AAII;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AADR;;AAII;EACI,SAAA;EACA,WAAA;EACA,mBAAA;AADR;;AAII;EACE,8BAAA;EACA,eAAA;EACA,eAAA;AADN;;AAIE;EAEE,aAAA;EACA,sBAAA;AAFJ;AAOI;EACE,mBAAA;EACA,8BAAA;AALN;AAQM;EACE,eAAA;EACA,gBAAA;AANR;AASM;EACE,aAAA;EACA,yBAAA;AAPR;AAWI;EACE,mBAAA;AATN;AAWM;EACE,SAAA;AATR;AAYM;EACE,qBAAA;AAVR;;AAeE;EACE,cAAA;EACA,YAAA;EACA,WAAA;EACA,8CAAA;AAZJ;;AAeE;EACE,aAAA;EACA,WAAA;AAZJ;;AAeE;EACE,aAAA;EACA,WAAA;AAZJ","sourcesContent":["\n    ion-select.select {\n        margin: 0px;\n    }\n\n    .row {\n        align-items: center;\n        white-space: nowrap;\n        display: flex;\n        align-items: center;\n    }\n\n    .red {\n        color: #d3001d;\n    }\n\n    .globalLimit {\n        padding-bottom: 10px;\n    }\n\n    .timeDelete, .timeRolloverPeriod, .timeRemoved, .timeAmountUsed, .timeNewLimitEffective, .timePendingLimitEffective {\n        display: none;\n        width: 100%;\n    }\n\n    .button-row {\n        justify-content: center;\n        display: grid;\n\n    }\n\n    .deposit-column {\n        flex-direction: row;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .label-colum {\n        display: flex;\n        align-items: center;\n    }\n\n    .label-text {\n        text-overflow: \"-\";\n        white-space: nowrap;\n    }\n\n    .deposit-column {\n        flex-direction: row;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    hr {\n        border: 0;\n        height: 1px;\n        background: #C2C2C2;\n    }\n\n    .error-message {\n      color: var(--ion-color-danger);\n      font-size: 12px;\n      margin-top: 4px;\n  }\n\n  .limit-section {\n    // margin-bottom: 20px;\n    display: flex;\n    flex-direction: column;\n    h4 {\n      // margin-bottom: 10px;\n    }\n\n    .limit-info {\n      align-items: center;\n      justify-content: space-between;\n      // margin-bottom: 10px;\n\n      .label-text {\n        font-size: 16px;\n        font-weight: 500;\n      }\n\n      .timeDelete {\n        display: flex;\n        justify-content: flex-end;\n      }\n    }\n\n    .new-limit-row {\n      align-items: center;\n\n      h5 {\n        margin: 0;\n      }\n\n      ion-input {\n        --padding-start: 10px;\n      }\n    }\n  }\n\n  .section-divider {\n    margin: 20px 0;\n    border: none;\n    height: 1px;\n    background-color: var(--ion-color-light-shade);\n  }\n\n  .rollover-period{\n    display: none;\n    width: 100%;\n  }\n\n  .new-limit-effective{\n    display: none;\n    width: 100%;\n  }\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
